import { api } from "..";

const endpoint = "/api/payment-tx";

export const getPaymentTxList = (queryParams) => {
  return api.get(`${endpoint}`, { params: queryParams });
};

export const getPaymentTxById = (id) => {
  return api.get(`${endpoint}/${id}`);
};

export const createPaymentTx = (data) => {
  return api.post(`${endpoint}`, data);
};

// Metadata-only edit (source bank account / bank reference / tracking key) — AmountPaid is append-only.
export const updatePaymentTx = (id, data) => {
  return api.put(`${endpoint}/${id}`, data);
};

export const deletePaymentTx = (id) => {
  return api.delete(`${endpoint}/${id}`);
};

export const exportPaymentTxPDF = async (paymentTxId) => {
  return await api.get(`${endpoint}/${paymentTxId}/pdf`, {
    responseType: "blob",
    headers: { Accept: "*/*" },
  });
};

// Exports every transaction on the given payment date (ISO "YYYY-MM-DD"), not a grid selection.
export const exportPaymentTxLayout = (companyId, paymentDate) => {
  return api.post(`${endpoint}/export-layout`, { companyId, paymentDate });
};

export const exportPaymentTxLayoutSelection = (paymentTxIds) => {
  return api.post(`${endpoint}/export-layout-selection`, paymentTxIds);
};
